import Button from "../../ui/Button/Button";
import "./Modal.css";

export default function Modal({ children, handleClose, className }) {
    return (
        <div className={`modal ${className ?? ''}`} onClick={handleClose}>
            <div className="modal_content" onClick={e => e.stopPropagation()}>
                <Button
                    onClick={handleClose}
                    className={'modal_close_btn'}
                >
                    &#9932;
                </Button>
                {children}
            </div>
        </div>
    );
}
